<template>
  <div class="wrapper">
    <div class="searchBox">
      <div class="longBox" @click="toSearch">
        <img src="../../assets/images/search/search.svg" alt />
        <span>请输入商品或品牌名称</span>
      </div>
    </div>
    <div class="blockArea">
      <van-list class="scroll" id='scrollTitle'>
        <div class="menuItem" v-for="(item, index) in second_classify" :key="index" @click="gochange(index)" :style="active == index
          ? { background: '#fff' }
          : { background: 'transparent' }">

          <span>{{item.category_name}}</span>
          <div class="line" v-if="active == index"></div>
        </div>
      </van-list>

      <van-list class="scroll" v-model="loading" :finished="finished" @load="getdata" :offset="20" id='scrollBox'>
        <div class="tabbox1">
          <div class="tabboxm" v-for="(item, index) in second_goods" :key="index" @click="golistdetail(item.nbr,item.rule_type)">
            <div class="tabboxmt">
              <img v-lazy="
                      item.commodity_logo + `${imgCrop}resize,w_500`
                    " alt />
              <div :class="item.quantity === '0' ? 'noNum' : 'noNum hide'">
                <img v-lazy="require('../../assets/images/noNum.png')" alt />
              </div>
            </div>
            <div class="right">
              <div class="tanboxmm1">
                {{ item.commodity_name }}
              </div>
              <div class="commoditySummary">
                {{ item.commodity_summary }}
              </div>
              <div class="saleNum">
                <span v-if="item.is_sales_show == '1'">已售：{{item.sales_num}}件</span>
              </div>
              <div class="right-bottom">
                <div class="tanboxmb">
                  <span v-if="item.rule_type=='1'">
                    <i>￥</i>{{
                    roleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${roleText}_price`]
                    }}
                  </span>
                  <span v-if="item.rule_type=='2'">
                    <i>￥</i>{{
                    newRoleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${newRoleText}_price`]
                    }}
                  </span>
                  <!-- <span v-if="parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2))!= 0">
                        <span>/</span>
                        <i>赚￥{{parseFloat((item[`min_sell_price`]-item[`min_${roleText}_price`]).toFixed(2))}}</i>
                      </span> -->
                  <!-- <div class="tanboxmbbb">
                    <span>￥{{ item.old_price }}</span>
                  </div> -->
                </div>
                <img class="addImg" v-lazy="require('../../assets/images/classification/addIcon.png')" alt />
              </div>

            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
      <img src="../../assets/images/index/top.svg" />
    </div>
  </div>
</template>

<script>
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        second_classify: [], //二级分类id
        second_goods: [], //二级分类商品
        loading: false, //上拉加载
        finished: true, //加载完成
        classifyindexid: "", //下标id
        active: 0, //初始显示那个类
        pageIndex: 0,
        numPerPage: 10,
        totalRows: 0,
        roleText: "sell", //用户身份文本
        newRoleText:'sell',
        scroll: 0,
        keepAlive: true,
        toTopShow: false,
        currentindex: "1", //当前下标
        sortType: "0",
        sortOrder: "1",
        style: 2,
      };
    },
    watch: {
      $route(to, from) {
        if (
          from.path == "/information" ||
          from.path == "/index" ||
          from.path == "/cart"
        ) {
          this.keepAlive = true;
        } else {
          this.keepAlive = false;
        }
      },
    },
    computed: {},
    methods: {
      gochange(index) {
        if (this.active == index) return false
        this.active = index
        this.pageIndex = 0;
        this.second_goods = [];
        this.setWeChatShare();
        this.getdata();
      },
      toSearch() {
        this.$router.push({
          path: "/searchlist",
          query: { supNbr: this.userInfo.nbr },
        });
      },
      golistdetail(nbr,type) {
        this.$router.push({
          path: type=='1'?"/listdetail":"/sourceListdetail",
          query: { nbr: nbr, supNbr:this.userInfo.nbr }
        });
      },
      scrollMenu() {
        let menuList = document.getElementsByClassName(`menuItem`)
        let height = menuList[0].offsetHeight * this.active
        document.getElementById(`scrollTitle`).scrollTop = height;
      },
      getSecondArea() {
        let that = this;
        this.$commonPost({
          jydm: "flow_70006",
          flow_70006: {
            type: "1",
          },
        })
          .then((response) => {
            let arr = [];
            if (response.category) {
              if (response.category.length > 0) {
                arr = response.category;
              } else {
                arr.push(response.category);
              }
            }
            // arr.unshift({
            //   category_name: "全部",
            //   image_path: "",
            //   nbr: "0",
            // })
            if (that.firstNbr) {
              for (let i = 0; i < arr.length; i++) {
                if (that.firstNbr == arr[i].nbr) {
                  that.active = i
                  break;
                }
              }
            }
            that.second_classify = arr;
            if (that.firstNbr) setTimeout(() => { that.scrollMenu() }, 0)
            if (arr.length > 0) {
              that.setWeChatShare();
              that.getdata();
            }
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
      getdata() {
        var that = this;
        this.loading = true;
        let nbr = this.second_classify[that.active].nbr
        if (nbr == '0') {
          this.$commonPost({
            jydm: "flow_70001",
            flow_70001: {
              sort_type: this.sortType,
              sort_order: this.sortOrder,
              page_index: this.pageIndex * this.numPerPage,
              num_per_page: this.numPerPage,
            }
          })
            .then(response => {
              let arr = [];
              if (response.commodityList) {
                if (response.commodityList.commodity.length > 0) {
                  arr = response.commodityList.commodity;
                } else {
                  arr.push(response.commodityList.commodity);
                }
              }
              that.second_goods = that.second_goods.concat(arr);
              that.loading = false;
              if (arr.length < this.numPerPage) {
                that.finished = true;
              } else {
                that.finished = false;
                that.pageIndex += 1;
              }
            })
            .catch(err => {
              this.$toast({
                message: err.message,
                duration: 2000
              });
            });
        } else {
          this.$commonPost({
            jydm: "flow_70008",
            flow_70008: {
              category_name: that.second_classify[that.active].category_name,
              page_index: this.pageIndex * this.numPerPage,
              num_per_page: this.numPerPage,
              type: "1",
              sort_type: this.sortType,
              sort_order: this.sortOrder,
            },
          })
            .then((response) => {
              let arr = [];
              if (response.commodity) {
                if (response.commodity.length > 0) {
                  arr = response.commodity;
                } else {
                  arr.push(response.commodity);
                }
              }
              that.second_goods = that.second_goods.concat(arr);
              that.loading = false;
              if (arr.length < this.numPerPage) {
                that.finished = true;
              } else {
                that.finished = false;
                that.pageIndex += 1;
              }
            })
            .catch((err) => {
              this.$toast({
                message: err.message,
                duration: 2000,
              });
            });
        }
      },
      handleScroll() {
        // 设备/屏幕高度
        let scrollTop = document.getElementById(`scrollBox`).scrollTop;
        if (scrollTop > 50) {
          this.toTopShow = true;
        } else {
          this.toTopShow = false;
        }
      },
      // 回到顶部动画
      toTopAnimate() {
        document.getElementById(`scrollBox`).scrollTop = 0;
      },
      setWeChatShare() {
        let option = {
          title: this.second_classify[this.active].category_name,
          desc: "全球好物，尽在有米",
          link: `${location.origin}/recommend?supNbr=${this.userInfo.nbr || ""
            }&firstNbr=${this.second_classify[this.active].nbr}`,
          images: this.second_classify[this.active].image_path || (this.cdnImgPath + '/images/default/xcx_share_default.jpg'),
        };
        this.weChatShare(option);
      },
      checkOption() {
        if (!(this.userInfo && this.userInfo.nbr)) {
          this.isLogin = 0;
          this.roleText = "sell";
          this.newRoleText = "sell";
        } else {
          this.getUserInfo();
          this.isLogin = 1;
        }
      },
      getUserInfo() {
        // 用户的基本信息(身份)
        this.$commonPost({
          jydm: "flow_10003",
          flow_10003: {
            user_nbr: this.userInfo.nbr,
          },
        })
          .then((response) => {
            if (response.role == 0 || response.role == 1) {
              this.roleText = "sell";
            } else if (response.role == 2) {
              this.roleText = "agent";
            } else if (response.role == 3) {
              this.roleText = "director";
            }
            if (response.new_role == 0 || response.new_role == 1) {
            this.newRoleText = "sell";
          } else if (response.new_role == 2) {
            this.newRoleText = "agent";
          } else if (response.new_role == 3) {
            this.newRoleText = "director";
          }
          })
          .catch((err) => {
            this.$toast({
              message: err.message,
              duration: 2000,
            });
          });
      },
    },
    created() {
      let index = this.getUrlParam("index") || 0;
      this.active = index;
    },
    mounted() { },
    // 被缓存时任执行
    activated() {
      document.title = "分类";
      this.checkOption();
      window.addEventListener("scroll", this.handleScroll, true);
      if (!this.keepAlive) {
        this.setWeChatShare();
        //将高度滚动到原来离开页面的高度
        if (document.getElementById(`scrollBox`)) {
          document.getElementById(`scrollBox`).scrollTop = this.scroll;
        }
        return false;
      } else {
        this.firstNbr = this.$route.query.firstNbr || '';
        this.pageIndex = 0;
        this.second_classify = [];
        this.second_goods = [];
        this.getSecondArea();
      }
    },
    beforeRouteLeave(to, from, next) {
      if (document.getElementById(`scrollBox`)) {
        this.scroll = document.getElementById(`scrollBox`).scrollTop;
      }
      window.removeEventListener("scroll", this.handleScroll, true);
      next();
    },
  };
</script>
<style scoped lang='stylus'>

</style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    height: calc(100vh - 1rem);
    background: #fff;
  }

  .searchBox {
    width: 100%;
    height: 0.88rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .longBox {
      width: 7.02rem;
      height: 0.6rem;
      background: #f9f9f9;
      border-radius: 0.3rem;
      display: flex;
      flex-direction: row;
      align-items: center;

      span {
        font-size: 0.28rem;
        color: #999;
        font-weight: 500;
      }

      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.2rem;
        margin-left: 0.18rem;
      }
    }
  }

  .blockArea {
    display: flex;
    flex-direction: row;
    padding-top: .1rem;
    box-sizing: border-box;
  }

  #scrollTitle {
    width: 1.9rem;
    background: #F6F6F6;
  }

  #scrollBox {
    flex: 1;
  }

  .scroll {
    height: calc(100vh - 1.98rem);
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }

  .scroll::-webkit-scrollbar {
    display: none;
  }

  .toTop {
    position: fixed;
    right: 0.2rem;
    z-index: 999;
    bottom: 2rem;
    width: 0.8rem;
    height: 0.8rem;
    background: rgba(51, 51, 51, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .toTop img {
    width: 0.4rem;
    height: 0.4rem;
  }

  .hide {
    display: none !important;
  }

  .menuItem {
    width: 100%;
    height: 1.06rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: .28rem;
    box-sizing: border-box;
    position: relative;

    .line {
      position: absolute;
      left: 0;
      top: .3rem;
      width: .14rem;
      height: .46rem;
      background: #22CE96;
    }

    span {
      font-size: .24rem;
      color: #333;
      font-weight: bold;
      line-height: .33rem;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      word-break: break-all;
      white-space: normal;
    }
  }

  .tabbox1 {
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 0 .2rem;

    .tabboxm {
      width: 100%;
      height: 2.32rem;
      padding: 0.1rem 0 .1rem .1rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;

      .tabboxmt {
        width: 2.1rem;
        height: 2.1rem;
        position: relative;

        img {
          width: 2.1rem;
          height: 2.1rem;
        }

        .noNum {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 0;
          left: 0;
          background: rgba(51, 51, 51, 0.3);
          width: 100%;
          height: 2.1rem;
          img {
            width: 2.1rem;
            height: 2.1rem;
          }
        }
      }

      .right {
        width: 2.8rem;
        display: flex;
        flex-direction: column;
        justify-content: start;
        height: 100%;
        position: relative;

        .tanboxmm1 {
          line-height: 0.33rem;
          height: 0.66rem;
          font-size: 0.24rem;
          font-weight: 500;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          word-break: break-all;
          white-space: normal;
        }

        .commoditySummary {
          margin-top: .1rem;
          color: #E59358;
          font-size: 0.24rem;
          font-weight: 500;
          line-height: 0.33rem;
          height: 0.33rem;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          word-break: break-all;
          white-space: normal;
        }

        .saleNum {
          margin-top: .1rem;
          color: #999;
          font-size: 0.24rem;
          font-weight: 400;
          line-height: 0.33rem;
          height: 0.33rem;
        }

        .right-bottom {
          margin-top: 0.1rem;
          height: .48rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          .tanboxmb {
            overflow: hidden;

            span:nth-of-type(1) {
              color: #E52B25;
              font-size: 0.34rem;
              font-weight: bold;

              i {
                font-size: 0.24rem;
              }
            }

            span:nth-of-type(2) {
              color: #e52b25;
              font-size: 0.24rem;

              span {
                color: #e52b25;
                font-size: 0.24rem;
                font-weight: 400;
              }

              i {
                font-weight: bold;
              }
            }
          }

          .addImg {
            width: .44rem;
            height: .44rem;
          }

          .tanboxmbbb {
            line-height: 0.34rem;
            margin-top: 0.06rem;
            margin-left: 0.05rem;

            span {
              color: #666 !important;
              font-size: 0.24rem !important;
              font-weight: 400 !important;
              text-decoration: line-through;
            }
          }
        }
      }
    }
  }

  .home-content-tab {
    width: 100%;
  }

  .home-content-tabtop {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
  }

  .home-content-tabtop::-webkit-scrollbar {
    display: none;
  }

  .home-content-tabtopm {
    width: 1.08rem;
    height: 0.56rem;
    font-size: 0.28rem;
    line-height: 0.56rem;
    text-align: center;
  }

  .tanboxmm2 {
    line-height: 0.32rem;
    margin: 0 0.24rem;
    margin-top: 0.15rem;
    font-size: 0.22rem;
    color: #999;
  }

  .home-content-tab {
    width: 100%;
    background: #fff;
    position: fixed;
    top: 1.68rem;
  }

  .home-content-tabtop {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
  }

  .home-content-tabtop::-webkit-scrollbar {
    display: none;
  }

  .home-content-tabtopm {
    width: 1.08rem;
    height: 0.56rem;
    font-size: 0.28rem;
    line-height: 0.56rem;
    text-align: center;
  }

  .nomore {
    width: 100%;
    text-align: center;
    color: #999999;
    line-height: 1rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/index/recommend.vue